// extracted by mini-css-extract-plugin
export default {"background":"ConditionalQuery_background__7yma6"};